/* eslint-disable consistent-return */
/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';
import {
  checkValidEmailAddress,
  API_DATE_FORMAT,
} from '../../shared/constants/Constants';
import AppButton from '../../shared/components/app-button/AppButton';
import RoundTripIntlEmailCard from './RoundTripIntlEmailCard';
import AppRadioInput from '../../shared/components/app-radio-input/AppRadioInput';
import {
  formatDate,
  getNewDate,
  isMobileWidth,
} from '../../shared/helper-utils/appUtils';
import AppNumberInput from '../../shared/components/app-number-input/AppNumberInput';
import { useAppContext } from '../../saas/AppConfigWrapper';

function RoundTripIntlEmailContent({ selectedFlights, searchRequest, onSend }) {
  const { appConfig } = useAppContext();
  const PREF_CLASS_DICT = {
    Y: 'Economy',
    W: 'Premium Economy',
    C: 'Business',
    F: 'First Class',
  };
  const [validationError, setValidationError] = useState(false);
  const [showBreakup, setShowBreakup] = useState(true);
  const [senderEmail, setSenderEmail] = useState('');
  const [showInput, setShowInput] = useState(true);
  const [markUpToBeAdded, setMarkupToBeAdded] = useState('');

  const handleSend = () => {
    setShowInput(false);
    if (senderEmail === '' || checkValidEmailAddress(senderEmail)) {
      setValidationError(true);
      setShowInput(true);
      return false;
    }

    setTimeout(() => {
      const content = document.getElementById('emialContent').innerHTML;
      onSend(senderEmail, content);
    }, 500);
  };

  return (
    <div>
      <div className="fs-14 px-sm-4">
        <div className="d-flex align-items-center gap-3 mb-1">
          <AppRadioInput
            id="true"
            name="showBrakup"
            labelText="With Fare"
            value=""
            onChange={() => setShowBreakup(true)}
            checked={showBreakup}
          />
          <AppRadioInput
            id="false"
            name="showBrakup"
            labelText="Without Fare"
            value=""
            onChange={() => setShowBreakup(false)}
            checked={!showBreakup}
          />
        </div>
        <Row className=" my-3 spacing-8 gapbetween">
          <Col lg={8} md={8} sm={12} xs={12}>
            <AppTextInput
              name="email"
              label={isMobileWidth() ? 'Email Address' : 'Email Address '}
              placeholderText=""
              value={senderEmail}
              required
              onChange={(e) => setSenderEmail(e.target.value)}
              errorText={validationError && 'Enter Email Address'}
            />
            {checkValidEmailAddress(senderEmail) &&
              validationError &&
              senderEmail !== '' && (
                <small className="app-error-text">
                  {' '}
                  Please Enter Valid Email id
                </small>
              )}
          </Col>
          <Col lg={4} md={4} sm={12} xs={12}>
            <AppNumberInput
              name="markUpToBeAdded"
              label="Markup"
              value={markUpToBeAdded}
              onChange={(d) => setMarkupToBeAdded(d)}
            />
          </Col>
        </Row>
      </div>
      <div className="d-flex justify-content-center align-items-center hide-in-mobile">
        <div className="overflow-auto " style={{ height: '300px' }}>
          <div id="emialContent">
            <div
              style={{
                width: '750px',
                color: '#000',
                padding: '1rem',
                marginLeft: 'auto',
                marginRight: 'auto',
              }}
            >
              <div
                className="show-no-border-in-mobile"
                style={{
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  border: '1px solid #ccc',
                  borderRadius: '8px',
                }}
              >
                <div
                  style={{
                    borderTopLeftRadius: '8px',
                    borderTopRightRadius: '8px',
                    color: '#fff',
                    backgroundColor: appConfig?.clientPrimaryColor,
                    fontSize: '14px',
                  }}
                >
                  <div
                    style={{
                      borderTopLeftRadius: '8px',
                      borderTopRightRadius: '16px',
                      padding: '16px',
                      fontSize: '12px',
                      borderBottom: '1px solid #ccc',
                    }}
                    className="d-none"
                  >
                    <table style={{ width: '100%' }}>
                      <tbody>
                        <tr>
                          <td
                            style={{
                              textAlign: 'left',
                              fontWeight: '600',
                              fontSize: '14px',
                            }}
                          >
                            {searchRequest.originLocation.split(',')[0]} -{' '}
                            {searchRequest.destinationLocation.split(',')[0]}
                          </td>
                          <td style={{ textAlign: 'end', fontSize: '12px' }}>
                            Traveler Class :{' '}
                            <span
                              style={{ fontWeight: '600', fontSize: '14px' }}
                            >
                              {PREF_CLASS_DICT[searchRequest.prefclass]}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: 'left' }}>
                            Travel Dates :{' '}
                            <span
                              style={{ fontWeight: '600', fontSize: '14px' }}
                            >
                              {formatDate(
                                getNewDate(searchRequest.onwarddate),
                                API_DATE_FORMAT,
                              )}{' '}
                              {formatDate(
                                getNewDate(searchRequest.returndate),
                                API_DATE_FORMAT,
                              )}
                            </span>
                          </td>
                          <td style={{ textAlign: 'end' }}>
                            Passenger(s):{' '}
                            <span
                              style={{ fontWeight: '600', fontSize: '14px' }}
                            >
                              {parseInt(searchRequest.numadults, 10)} Adult
                              {parseInt(searchRequest.numchildren, 10) > 0 &&
                                ` ${parseInt(
                                  searchRequest.numchildren,
                                  10,
                                )} Child`}
                              {parseInt(searchRequest.numinfants, 10) > 0 &&
                                ` ${parseInt(
                                  searchRequest.numinfants,
                                  10,
                                )} Infant`}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                {selectedFlights.map((selectedFlight, index) => (
                  <RoundTripIntlEmailCard
                    key={selectedFlight.fare.nextraflightkey}
                    onwardFlight={selectedFlight.onwardFlight}
                    returnFlight={selectedFlight.returnFlight}
                    isLast={index === selectedFlights.length - 1}
                    index={index}
                    markUpToBeAdded={markUpToBeAdded}
                    showHideFare={showBreakup}
                    fare={selectedFlight.fare}
                    searchRequest={searchRequest}
                    showInput={showInput}
                    onFareUpdate={() => {}}
                  />
                ))}
                <div
                  style={{
                    backgroundColor: '#333333',
                    borderTop: '1px solid #ccc',
                    color: '#fff',
                    padding: '10px',
                    fontSize: '12px',
                    borderBottomLeftRadius: '8px',
                    borderBottomRightRadius: '8px',
                  }}
                  className="d-none"
                >
                  <span style={{ fontSize: '14px', marginBottom: '10px' }}>
                    Terms & Conditions:
                  </span>
                  <ul>
                    <li>
                      All Travel timings are as per the local time in 24hrs
                      format
                    </li>
                    <li>
                      Check passenger name and Travel Itinerary details
                      carefully
                    </li>
                    <li>
                      Names provided should be with Valid Government Approved
                      Photo ID/ Passport
                    </li>
                    <li>
                      Automated Ticketing time limit provided as per airline
                    </li>
                    <li>
                      Ensure Sufficient Funds are available for confirmation of
                      services
                    </li>
                    <li>
                      Fares and Taxes are subject to availability at the time of
                      issuance
                    </li>
                    <li>
                      We are not liable if any increase occurs due to ROE
                      fluctuation and taxes
                    </li>
                    <li>
                      Check all Visa requirement for Destination and Transit
                      country with the respective airline and embassy
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-end my-2">
        <AppButton
          variant="primary"
          onClick={handleSend}
          btnText="Send Email"
        />
      </div>
    </div>
  );
}

RoundTripIntlEmailContent.propTypes = {
  searchRequest: PropTypes.object.isRequired,
  selectedFlights: PropTypes.array.isRequired,
  onSend: PropTypes.func.isRequired,
};

export default RoundTripIntlEmailContent;
